/*
**************************** 
홈페이지 브랜드 소개
*****************************
*/

import React from "react";

export default function Brand(props) {

    return (
        <div>
            <div className="mt-5 pt-2">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item small"><a href="#">엘포박스</a></li>
                    <li className="breadcrumb-item active small">브랜드소개</li>
                </ol>
            </div>

            <div className="container-custom w-100">

                <img className="w-100 img-fluid" src="/img/toktokbox/toktokbox_01.gif"></img>
                <img className="w-100 img-fluid" src="/img/toktokbox/toktokbox_02.png"></img>
                <img className="w-100 img-fluid" src="/img/toktokbox/toktokbox_03.gif"></img>
                <img className="w-100 img-fluid" src="/img/toktokbox/toktokbox_04.png"></img>
                <img className="w-100 img-fluid" src="/img/toktokbox/toktokbox_05.png"></img>
                <img className="w-100 img-fluid" src="/img/toktokbox/toktokbox_06.png"></img>
                <img className="w-100 img-fluid" src="/img/toktokbox/toktokbox_07.png"></img>
                <img className="w-100 img-fluid" src="/img/toktokbox/toktokbox_08.gif"></img>
                <img className="w-100 img-fluid" src="/img/toktokbox/toktokbox_09.png"></img>
                <img className="w-100 img-fluid" src="/img/toktokbox/toktokbox_10.png"></img>
                <img className="w-100 img-fluid" src="/img/toktokbox/toktokbox_11.png"></img>
                <img className="w-100 img-fluid" src="/img/toktokbox/toktokbox_12.gif"></img>
                <img className="w-100 img-fluid" src="/img/toktokbox/toktokbox_13.png"></img>
                <img className="w-100 img-fluid" src="/img/toktokbox/toktokbox_14.gif"></img>
                <img className="w-100 img-fluid" src="/img/toktokbox/toktokbox_15.png"></img>
                <img className="w-100 img-fluid" src="/img/toktokbox/toktokbox_16.gif"></img>
                <img className="w-100 img-fluid" src="/img/toktokbox/toktokbox_17.png"></img>
                <img className="w-100 img-fluid" src="/img/toktokbox/toktokbox_18.gif"></img>
                <img className="w-100 img-fluid" src="/img/toktokbox/toktokbox_19.png"></img>
                <img className="w-100 img-fluid" src="/img/toktokbox/toktokbox_20.png"></img>
                <img className="w-100 img-fluid" src="/img/toktokbox/toktokbox_21.gif"></img>
                <img className="w-100 img-fluid" src="/img/toktokbox/toktokbox_22.png"></img>
                <img className="w-100 img-fluid" src="/img/toktokbox/toktokbox_23.png"></img>
                <img className="w-100 img-fluid" src="/img/toktokbox/toktokbox_24.gif"></img>
                <img className="w-100 img-fluid" src="/img/toktokbox/toktokbox_25.png"></img>
                <img className="w-100 img-fluid" src="/img/toktokbox/toktokbox_26.png"></img>
                <img className="w-100 img-fluid" src="/img/toktokbox/toktokbox_25.png"></img>
            </div>
        </div>

    )
}